import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";

import type {IncidentReport} from "../types";

const PATH = "incidentreport";

class IncidentsApi extends ResourceApi<IncidentReport> {
  constructor() {
    super(PATH);
  }

  getIncidentReportTypes(): Promise<
    AxiosResponse<{incident_report_types: {incident_report_type_id: number; type: string}[]}>
  > {
    return this.get("incidentreporttype");
  }
}

export const incidentsApi = new IncidentsApi();
